import { styled } from '@mui/material';

export const Separator = styled('div')`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.palette.white.main};
  margin: 8px auto;
`;

export const Reaction = styled('div')``;

export const ReactionWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LeftGroup = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ReactionButtonsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const CounterContainer = styled('div')`
  cursor: pointer;
  font-size: 14px;
`;

export const ExpandText = styled('div')`
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 400;
`;
